import React from "react";

import { BarChart as BarChartComponent } from "heat-next";

import { useSessionDetailsContext } from "@/context/session-details/session-details";

import { ComponentWrapper } from "@/pages/shared/shared.styles";

import ContentLoader from "@/components/content-loader/content-loader";
import EmptyState from "@/components/empty-state/empty-state";
import { EmptyStateType } from "@/components/empty-state/empty-state.types";

const BarChart = () => {
    const { barChartPayload, isFetchingDashboardData, isErrorDashboardData } =
        useSessionDetailsContext();

    const data = barChartPayload?.data;
    const config = barChartPayload?.config;

    if (isFetchingDashboardData) {
        return <ContentLoader height="18rem" />;
    }

    if (isErrorDashboardData && !barChartPayload) {
        return (
            <ComponentWrapper>
                <EmptyState
                    title="error-state:title"
                    emptyStateType={EmptyStateType.Error}
                    minHeight="18rem"
                />
            </ComponentWrapper>
        );
    }

    if (!data || !config) {
        return (
            <ComponentWrapper>
                <EmptyState
                    title="session-details:no-data:empty-state:title"
                    emptyStateType={EmptyStateType.Charts}
                    minHeight="18rem"
                />
            </ComponentWrapper>
        );
    }

    return <BarChartComponent data={data} config={config} minHeight="18rem" />;
};

export default BarChart;
